import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AdminSidebar } from './Dashboard';
import api from '../../services/api';

const STATUS = {
  aguardando:        { label:'Aguardando',       color:'#7a5c00', bg:'rgba(216,189,105,.18)' },
  em_analise:        { label:'Em análise',        color:'#2563eb', bg:'rgba(37,99,235,.1)'   },
  aprovado:          { label:'Aprovado',          color:'#1e7d47', bg:'rgba(30,125,71,.12)'  },
  recusado:          { label:'Recusado',          color:'#be2e2e', bg:'rgba(190,46,46,.1)'   },
  ajuste_solicitado: { label:'Ajuste solicitado', color:'#c85718', bg:'rgba(200,87,24,.12)'  },
};

export default function AdminSolicitacoes() {
  const [sol, setSol] = useState([]);
  const [sparams] = useSearchParams();
  const [filtroStatus, setFiltroStatus] = useState(sparams.get('status') || '');

  const carregar = (s = filtroStatus) =>
    api.get(`/admin/solicitacoes${s ? `?status=${s}` : ''}`).then(({ data }) => setSol(data)).catch(() => {});

  useEffect(() => { carregar(); }, [filtroStatus]);

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-title">Solicitações de anúncio</h1>
          <select
            value={filtroStatus}
            onChange={e => setFiltroStatus(e.target.value)}
            style={{ padding:'8px 14px', border:'1px solid var(--border)', borderRadius:'var(--r-sm)', fontSize:13, background:'#fff' }}>
            <option value="">Todas</option>
            {Object.entries(STATUS).map(([v, s]) => <option key={v} value={v}>{s.label}</option>)}
          </select>
        </div>

        <table className="tabela">
          <thead><tr><th>#</th><th>Anunciante</th><th>Veículo</th><th>Status</th><th>Enviado em</th><th>Ação</th></tr></thead>
          <tbody>
            {sol.map(s => {
              const dados = typeof s.dados_veiculo === 'string' ? JSON.parse(s.dados_veiculo) : s.dados_veiculo || {};
              const st = STATUS[s.status] || STATUS.aguardando;
              return (
                <tr key={s.id}>
                  <td style={{ color:'var(--ink-muted)', fontSize:12 }}>#{s.id}</td>
                  <td><div style={{ fontWeight:700 }}>{s.nome_anunciante}</div><div style={{ fontSize:11, color:'var(--ink-muted)' }}>{s.whatsapp_anunciante}</div></td>
                  <td style={{ fontSize:14 }}>{dados.marca} {dados.modelo} {dados.ano}</td>
                  <td>
                    <span style={{ background:st.bg, color:st.color, border:`1px solid ${st.color}33`, padding:'4px 11px', borderRadius:'var(--r-sm)', fontSize:10, fontWeight:900, letterSpacing:1, textTransform:'uppercase' }}>
                      {st.label}
                    </span>
                  </td>
                  <td style={{ fontSize:12, color:'var(--ink-muted)' }}>{new Date(s.created_at).toLocaleDateString('pt-BR')}</td>
                  <td><Link to={`/admin/solicitacoes/${s.id}`} className="btn btn-primary btn-sm">Analisar</Link></td>
                </tr>
              );
            })}
            {sol.length === 0 && <tr><td colSpan={6} style={{ textAlign:'center', color:'var(--ink-muted)', padding:36 }}>Nenhuma solicitação encontrada.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
